import React, {Component} from 'react';
import Tables from './Table'
class Projects extends Component{
  render(){
    return(
      <React.Fragment>
        <Tables/>
      </React.Fragment>
    )
  }
}
export default Projects;


// WEBPACK FOOTER //
// ./src/views/Projects/Projects/Projects.js